import { useTranslation } from 'react-i18next'
import { ORDER_KINDS, ORDER_STATUSES } from 'service/OrdersService'

import styles from './OrdersToolbar.module.scss'

const OrdersToolbar = ({ filter, setFilter, onReload, onNew }) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.toolbar}>
      <h2 className={styles.title}>{t('ordersPage.studentOrders')}</h2>
      <select
        value={filter.status}
        onChange={(e) => setFilter({ ...filter, status: e.target.value })}
        className="unv-input"
      >
        <option value="">{t('ordersPage.allStatuses')}</option>
        {ORDER_STATUSES.map((s) => (
          <option key={s.value} value={s.value}>{s.label}</option>
        ))}
      </select>
      <select
        value={filter.kind}
        onChange={(e) => setFilter({ ...filter, kind: e.target.value })}
        className="unv-input"
      >
        <option value="">{t('ordersPage.allTypes')}</option>
        {ORDER_KINDS.map((k) => (
          <option key={k.value} value={k.value}>{k.label}</option>
        ))}
      </select>
      <input
        type="text"
        value={filter.q}
        onChange={(e) => setFilter({ ...filter, q: e.target.value })}
        onKeyDown={(e) => e.key === 'Enter' && onReload()}
        placeholder={t('ordersPage.searchPlaceholder')}
        className="unv-input"
      />
      <button className="unv-btn" onClick={onReload}>{t('ordersPage.find')}</button>
      <button className="unv-btn unv-btn--primary" onClick={onNew}>
        {t('ordersPage.newOrder')}
      </button>
    </div>
  )
}

export default OrdersToolbar
